module.exports = __webpack_public_path__ + "assets/img/conversion_coin.23a40636.png";